module.exports = __webpack_public_path__ + "c59e6543d90169e5ffec78b1e342f1a5.png";


//////////////////
// WEBPACK FOOTER
// ./shared/images/facebook.png
// module id = 968
// module chunks = 2